/* import __COLOCATED_TEMPLATE__ from './ai-title-selector.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { cached } from 'tracked-toolbox';
import type Conversation from 'embercom/objects/inbox/conversation';

interface Args {
  conversation: Conversation;
}

interface Signature {
  Args: Args;
}

export default class Inbox2AiTitleSelector extends Component<Signature> {
  @cached
  get displayTitle() {
    if (!this.args.conversation.id) {
      return '—';
    }

    return this.args.conversation.aiTitle || '—';
  }

  @cached
  get hasAiTitle() {
    return !!this.args.conversation.aiTitle;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::AiTitleSelector': typeof Inbox2AiTitleSelector;
    'inbox2/conversation-details-sidebar/ai-title-selector': typeof Inbox2AiTitleSelector;
  }
}
